import React from "react";
import "./Experience.css";

function Experience() {
  return (
    <div className="experience" id="Expérience">
      <div className="achievement">
        <div className="circle">1+</div>
        <span>année</span>
        <span>Experience</span>
      </div>
      <div className="achievement">
        <div className="circle">1+</div>
        <span>Projet</span>
        <span>complété</span>
      </div>
      <div className="achievement">
        <div className="circle">1+</div>
        <span>Travail</span>
        <span>service</span>
      </div>
    </div>
  );
}

export default Experience;
